export default __webpack_public_path__ + "static/media/thumb_2_lt.cd2354d9.png";